import { createFileRoute } from "@tanstack/react-router";
import { MigrateComponent } from "../components/Routing/Migrate";

export const Route = createFileRoute("/migrate")({
  component: MigrateComponent,
  staticData: { titleKey: "migrate.title" },
});
